import * as React from "react";
import { Col, Row, Space } from "antd"

export const RenderAddressAndPropertyColumns = ((props:{data: Array<{ address?: string; community?: string }>, filed: string, styles:any})=> {
    let filedStr = props.filed.toLocaleLowerCase()
    return(
        <Space.Compact direction="vertical" style={props.styles?.addressAndPropertyColumns}>
            {props.data?.map((item, index) => {
                return <Row key={`${filedStr}-${item?.address || item?.community || index}-${index}`} style={ index != props.data?.length - 1 ? props.styles?.addressAndPropertyRow : props.styles?.addressAndPropertyRowLast}>
                            <Col span={24}>
                                {filedStr.toLocaleLowerCase() == 'id' ? index : filedStr == 'address' ? item?.address : filedStr == 'property'? item?.community : <></>}                                    
                            </Col>
                        </Row>
            })}
        </Space.Compact>
    )
})
